module.exports = __webpack_public_path__ + "media/icons/why-95cd3ba8.svg";